import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { capitalize } from 'underscore.string';
import {
  FormGroup,
  Label,
} from '@bingads-webui-react/primitive';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { Input, TextArea } from '@bingads-webui-react/primitive-validation';
import { HelpPopup } from '@bingads-webui-react/help-popup';

const getStyle = () => ({
  formGroup: {
    margin: '0px !important',

    '& input, textarea': {
      marginBottom: '30px',
    },
    '& input.error, textarea.error': {
      marginBottom: '9px',
    },
  },
});

class CustomColumnFormInputUnStyled extends React.PureComponent {
  static propTypes = {
    i18n: PropTypes.shape({ getString: PropTypes.func }),
    name: PropTypes.string.isRequired,
    inputClassName: PropTypes.string.isRequired,
    maxLength: PropTypes.number.isRequired,
    inputValue: PropTypes.string.isRequired,
    classes: PropTypes.shape().isRequired,
    onInputChange: PropTypes.func,
    helpTopic: PropTypes.string,
    helpLabel: PropTypes.string,
    isTextArea: PropTypes.bool,
    inputLabelId: PropTypes.string.isRequired,
  };

  static defaultProps = {
    i18n: { getString: key => key },
    onInputChange: _.noop,
    helpTopic: 'DEFAULT_HELP_TOPIC',
    helpLabel: 'DEFAULT_HELP_LABEL',
    isTextArea: false,
  };

  render() {
    const {
      inputLabelId,
      name,
      isTextArea,
      helpLabel,
      helpTopic,
      classes,
      i18n,
      inputClassName,
      maxLength,
      inputValue,
      onInputChange,
    } = this.props;
    const capitalName = capitalize(name);
    const TextInput = isTextArea ? TextArea : Input;

    return (
      <FormGroup className={classes.formGroup}>
        <Label id={inputLabelId} >
          {i18n.getString(`CustomColumn_Column${capitalName}Label`)}
          <HelpPopup aria-label={helpLabel} topic={helpTopic} />
        </Label>
        <TextInput
          className={classNames(inputClassName, name)}
          maxLength={maxLength}
          name={name}
          aria-labelledby={inputLabelId}
          id={`custom-column-${name}`}
          value={inputValue}
          onChange={onInputChange}
          validationProps={{ field: name }}
        />
      </FormGroup>
    );
  }
}

export const CustomColumnFormInput = withDefaultStyles(CustomColumnFormInputUnStyled, getStyle);
